import wApi from "@/plugins/wApi/index";
import store from "@/store/index";
import Vue from 'vue';

// Local Storage 혹은 SessionStorage에 저장될 Token KeyName
const tokenName = "m3dHubEditor__token";

// Account 개발시 사용 개발용
// const disableAccount = process.env.NODE_ENV !== "production"; // 'development'
// 배포 및 기타 개발시 사용
// const disableAccount = process.env.VUE_APP_PROTOCOL ? true : false;
const disableAccount = false;
let defaultUser = false;

export default async (to, from, next) => {
  if (disableAccount) {
    if (!store.getters.loaded) store.commit("setState", ["loaded", true]);
    return next();
  }

  /* 화면 비율을 높여 볼 경우 홈페이지에 한하여 비율 조정 */
  const isHighDPI = window.matchMedia && window.matchMedia("(min-resolution: 144dpi)").matches;
  if (!to.path.startsWith("/process") && !to.path.startsWith("/protocol") && isHighDPI) {

    Vue.nextTick(() => {
      const appElement = document.getElementById("app");
      if (appElement) {
        appElement.style.maxWidth = '153.84615384615387vw';
      }
    });
  } else {
    document.documentElement.classList.add('default-dpi');
  }


  const requireAuth   = to.matched.some((record : any) => record.meta.requireAuth);
  const requireNoAuth = to.matched.some((record : any) => record.meta.requireNoAuth);
  let user = store.getters.user;

  // console.log({
  //   requireAuth , 
  //   requireNoAuth , 
  // }) ; 

  if (!store.getters.loaded) {
    // await store.dispatch("getTypes");
    try {
      user = await store.dispatch("getMe", wApi);
      store.commit("setState", ["loaded", true]);
    } catch (error) {
      // console.log(error);
      store.commit("setState", ["loaded", true]);
    }
  }

  // console.log({ to , from , user , requireAuth , requireNoAuth })
  if ( user == null || user.error ) {
    switch ( to.path ) {
      case '/platform/search' : 
      case '/platform/detail' :
      case '/register-application' :
      case '/account/mypage' :
      case '/account/mypage/createdList' :
      case '/account/mypage/CreatedDetail' :
      case '/account/mypage/lit-token' :
        return next( '/account/login' ) ; 
      default : 
        if( to.path.startsWith("/process") || to.path.startsWith("/protocol") || to.path.startsWith("/experiment") || to.path.startsWith("/literature") || to.path.startsWith("/data-visualization") ){
          return next( '/account/login' ) ; 
        }else{
          return next() ; 
        }
    }
  } else {
    if( !user.admin && !user.assistant && !user.committee && !user.super&& !user.generalManager ){
      defaultUser = true;
    }

    /*기관코드 체크*/
    if (
        (user.companyCode == null || user.companyCode == "" )
        && (to.path.startsWith("/process") || to.path.startsWith("/experiment")  || to.path.startsWith("/visualization") )
    ) {
        return next('/platform');
    }

    if( defaultUser && ( to.path.startsWith("/process") || to.path.startsWith("/protocol") ) ){
      return next( '/platform' ) ; 
    }else{
      if(to.path.startsWith("/process/editor") || to.path.startsWith("/protocol/editor")) {
        const {fullPath, path, query} = to;
        sessionStorage.setItem('editor-url', JSON.stringify({fullPath, path, query}));
      }
    }
    
    switch( to.path ){
      case '/protocol/equiment' :
        if( !user.admin && !user.super && !user.assistant && !user.committee && !user.generalManager ) return next( '/' ) ;
        else return next(); 
      default :
       return next() ;
    }
  } 

  return ; 
 

  // console.log('requireAuth: ' , requireAuth ) ; 
  // console.log('user: ' , user ) ; 

  if (requireAuth) {
    // console.log("%cbeforeEach.ts line:33 requireAuth,user", "color: #007acc;", requireAuth, user);
    // 사용자만 접근 가능
    if (user) {
      // 사용자가 있는 경우
      // store.dispatch( 'CommNew/setInitInfo2' , { user : store.getters.user , query : {}});
      // let { user , $route : { query }} = this ; 
      // this.setInitInfo({ user , query }) ; 
      next();
    } else {
      // 사용자가 없는 경우
      // console.log("%cHello beforeEach.ts line:39 ", "background: green; color: white; display: block;");
      // next("/account/login");
      next(process.env.VUE_APP_PROTOCOL ? "/platform" : "/account/login");
    }
  } else if (requireNoAuth) {
    if (user) {
      next(from);
    } else {
      next();
    }
  } else {
    // next("/account/login");
    // next(from);
    next();
  }
};